module.exports = __webpack_public_path__ + "img/08.79b14896.png";